import React, { useState, useEffect } from "react";
import axios from "../../axios/AxiosInstance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AvailableTable = ({ candidate, candidates, setCandidates }) => {
  const [availabilities, setAvailabilities] = useState(
    candidate.availabilities || [],
  );
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const days = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
  ];

  const periods = ["matin", "après-midi", "soir", "nuit"];

  // Met à jour la disponibilité lorsque l'utilisateur coche/décoche une case
  const handleCheckboxChange = (day, period) => {
    const availability = `${day} : ${period}`;
    setAvailabilities((prevAvailabilities) => {
      if (prevAvailabilities.includes(availability)) {
        // Si déjà présent, on le retire
        return prevAvailabilities.filter((item) => item !== availability);
      } else {
        // Sinon on l'ajoute
        return [...prevAvailabilities, availability];
      }
    });
  };

  // Fonction pour vérifier si une case doit être cochée
  const isChecked = (day, period) => {
    return availabilities.includes(`${day} : ${period}`);
  };

  // Fonction pour vérifier si toutes les cases d'une période sont sélectionnées
  const isAllSelected = (period) => {
    return days.every((day) => availabilities.includes(`${day} : ${period}`));
  };

  // Fonction pour sélectionner/désélectionner toutes les disponibilités d'une période
  const toggleSelectPeriod = (period) => {
    const select = !isAllSelected(period); // Si toutes les cases sont sélectionnées, on désélectionne, sinon on sélectionne
    let newAvailabilities = [...availabilities];

    days.forEach((day) => {
      const availability = `${day} : ${period}`;
      if (select && !newAvailabilities.includes(availability)) {
        newAvailabilities.push(availability);
      } else if (!select) {
        newAvailabilities = newAvailabilities.filter(
          (item) => item !== availability,
        );
      }
    });

    setAvailabilities(newAvailabilities);
  };

  const updateCandidate = () => {
    setIsLoading(true);
    axios
      .post(`tempworker-candidate/${candidate._id}/update`, {
        availabilities,
      })
      .then((res) => {
        const newCandidate = res.data;
        const candidateIndex = candidates.findIndex(
          (obj) => obj._id === newCandidate._id,
        );
        candidates[candidateIndex] = newCandidate;
        setCandidates([...candidates]);
        toast.success("Modifications enregistrées!");
        setIsLoading(false);
      })
      .catch((e) => {
        if (e.response.data.statusCode === 403) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  return (
    <div>
      <table className="min-w-full border-collapse">
        <thead>
          <tr>
            <th className="py-2 px-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
              Jour
            </th>
            {periods.map((period) => (
              <th
                key={period}
                className="py-2 px-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200 cursor-pointer"
                onClick={() => toggleSelectPeriod(period)} // Toggle selection pour la période
              >
                {period.charAt(0).toUpperCase() + period.slice(1)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {days.map((day, index) => (
            <tr
              key={index}
              className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
            >
              <td className="py-2 px-3 text-sm text-gray-900 font-medium border border-gray-200">
                {day}
              </td>
              {periods.map((period) => (
                <td
                  key={period}
                  className="py-2 px-3 text-center border border-gray-200"
                >
                  <input
                    type="checkbox"
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    checked={isChecked(day, period)} // Vérifie si la case doit être cochée
                    onChange={() => handleCheckboxChange(day, period)} // Appelle la fonction pour mettre à jour availabilities
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-end">
        <button
          onClick={updateCandidate}
          disabled={isLoading}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded"
        >
          {isLoading ? "Enregistrement..." : "Enregistrer les modifications"}
        </button>
      </div>
    </div>
  );
};

export default AvailableTable;
